export enum OdometerDigitType {
  Unknown = 'unknown',
  FiveDigit = 'five_digit_odometer',
  SixDigit = 'six_digit_odometer',
  SevenDigit = 'seven_digit_odometer'
}
